import { Form, Input, Modal, Typography } from 'antd';
import React, { useEffect } from 'react';
import { expirationIndexToReadable, daysToExpirationIndex } from '../utils/expirationIndexToReadable';

import CacheExpirationSlider from './CacheExpirationSlider';

const { Paragraph } = Typography;

export const NewRuleModal = ({ showModal, daysInterval, isAddSettingLoading, onSubmit, onCancel }) => {
  const [form] = Form.useForm();
  const cacheExpirationIndex = Form.useWatch('cacheExpirationHours', form);

  const cacheExpirationLabel = `Cache Expiration (${expirationIndexToReadable(cacheExpirationIndex)})`;

  const [startDay] = daysInterval;
  useEffect(() => {
    form.setFieldsValue({ cacheExpirationHours: daysToExpirationIndex(startDay), rule: '' });
  }, [showModal]);

  return (
    <Modal
      title="Add rule"
      open={showModal}
      onCancel={onCancel}
      onOk={() => {
        form.submit();
      }}
      confirmLoading={isAddSettingLoading}
    >
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          label="Rule"
          name="rule"
          rules={[
            {
              required: true,
              message: 'Please enter a URL pattern',
            },
          ]}
        >
          <Input placeholder="Add URL pattern" autoFocus />
        </Form.Item>
        <CacheExpirationSlider daysInterval={daysInterval} value={startDay * 24} label={cacheExpirationLabel} />
      </Form>
      <Paragraph>Please note that this change may lead to an increase in the monthly render counter</Paragraph>
    </Modal>
  );
};
